import { render } from "./CompanyTypesList.vue?vue&type=template&id=5fd08d44&scoped=true"
import script from "./CompanyTypesList.vue?vue&type=script&lang=js"
export * from "./CompanyTypesList.vue?vue&type=script&lang=js"

import "./CompanyTypesList.vue?vue&type=style&index=0&id=5fd08d44&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd08d44"]])

export default __exports__